<template>
	<div>
    <spinner v-if="submitting"/>
    <template v-if="!loadFailed && !success && !submitting">
      <b-form-group
        :state="errors.first('password') || (password && !isValidPassword) ? false : true"
        :invalid-feedback="errors.first('password') || passwordErrorMessage"
        label="Ingresa tu nueva contraseña" label-for="password"
        description="Recomendaciones: Agrega números y mayúsculas. Usa palabras poco comunes. Evita repetir palabras o caractereres. Agrega una o dos palabras."
      >
        <b-form-input
          :state="errors.first('password') || (password && !isValidPassword) ? false : null"
          v-validate="'required'"
          ref="password"
          @keyup="errorMessage = ''"
          v-model="password"
          name="password"
          id="password"
          type="password"
        />
      </b-form-group>

      <b-progress
        v-show="password"
        class="mb-4"
        :value="passwordScore"
        :max="4"
        animated
        :variant="isValidPassword ? 'success' : 'danger'"
      />

      <b-form-group
        :state="errors.first('confirmPassword') ? false : true"
        :invalid-feedback="errors.first('confirmPassword')"
        label="Confirma tu contraseña" label-for="confirmPassword"
      >
        <b-form-input
          :state="errors.first('confirmPassword') ? false : null"
          v-validate="'required|confirmed:password'"
          @keyup="errorMessage = ''"
          v-model="confirmPassword"
          name="confirmPassword"
          id="confirmPassword"
          type="password"
        />
      </b-form-group>

      <div class="alert alert-danger" role="alert" v-show="errorMessage">
        {{errorMessage}}
      </div>

      <div class="row pr-3 d-flex justify-content-end">
        <b-button :disabled="submitted" @click="validateBeforeSubmit" variant="primary" class="cursor-pointer">
          <img src="../assets/spinner.gif" width="20rem" v-show="submitted">
          Cambiar contraseña
        </b-button>
      </div>
    </template>

    <template v-if="loadFailed && !success && !submitting">
      <div class="alert alert-danger" role="alert">
        {{errorMessage}}. Enlace invalido.
      </div>
      <div class="row pr-3 d-flex justify-content-end">
        <b-button variant="primary" class="cursor-pointer" @click="goToRecover()">
          ← Volver a solicitar
        </b-button>
      </div>
    </template>

    <template v-if="success  && !loadFailed  && !submitting">
      <div class="alert alert-success" role="alert">
        Tu contraseña se ha actualizado correctamente
      </div>
      <div class="row pr-3 d-flex justify-content-end">
        <b-button variant="primary" class="cursor-pointer" @click="goToRecover()">
          ← Volver a recuperar
        </b-button>
      </div>
    </template>
	</div>
</template>

<script>
import axios from 'axios';
import utils from '../other/utils.js';
import passwordValidator from 'zxcvbn';

export default {
  props: ['uuid'],
  name: 'change-password',
  async created () {
    try {
      this.submitting = true;

      if (!this.uuid) {
        this.loadFailed = true;
        this.errorMessage = 'Enlace invalido';
        return;
      }

      await axios.get(`/users/verify-token/${this.uuid}`);

    } catch (error) {
      this.loadFailed = true;
      this.errorMessage = utils.getHumanErrorMessage(error, 'TOKEN');
    } finally {
      this.submitting = false;
    }
  },
  watch: {
    password () {
      this.isValidPassword = false;
      let passwordScore = passwordValidator(this.password);
			this.passwordScore = passwordScore.score;
      let passwordLength = this.password.length;

			if (this.passwordScore > 2 && (passwordLength > 7 && passwordLength < 21)) {
				this.isValidPassword = true;
			} else if (!this.password || passwordLength == 0) {
				this.passwordErrorMessage = 'Introduce la contraseña';
			} else if (passwordLength < 7 || passwordLength > 21) {
				this.passwordErrorMessage = 'La contraseña debé ser de entre 8 y 20 caracteres';
			} else if (this.passwordScore < 3) {
				this.passwordErrorMessage = 'Contraseña débil, se sugieren dos palabras separadas por un punto y usar palabras poco comunes';
			}
    }
  },
  data () {
    return {
      password: '',
      confirmPassword: '',
      submitted: false,
      submitting: false,
      errorMessage: '',
      passwordErrorMessage: '',
      success: false,
      loadFailed: false,
      isValidPassword: false,
      passwordScore: 2
    };
  },
  methods: {
    async validateBeforeSubmit ()	{
			try {
        this.submitted = true;

        let validationResult = await this.$validator.validateAll();
        if (!validationResult) return;

        if (!this.isValidPassword) return;

        let body = {
          password: this.password,
          passwordConfirm: this.confirmPassword,
          tokenId: this.uuid
        };

        let response = await axios.post('users/set-password', body);
        this.success = true;

			} catch (error) {
        this.errorMessage = utils.getHumanErrorMessage(error, 'USERS');
			} finally {
				this.submitted = false;
      }
    },
    goToRecover () {
      this.$router.push('/');
    }
  }
};
</script>

<style>
.date {
    background-color: white !important;
    opacity: 1 !important;
		margin-right: .5rem;
}

.vdp-datepicker {
  margin-right: .5rem;
}
</style>



// WEBPACK FOOTER //
// ChangePassword.vue?be8f6814